<template>
    <div>
        <ul>
            <!-- new card -->
            <li v-if="CreateCardButtonActive && createEnabled" 
                 class="lb-project-menu-item pt-4 pb-4" @click="$emit('toggleCreation')"
                :class="{ 'active': creationEnabled }">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-plus-circle-outline"></i>
                </span>
                
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('project.add_card') }}-->
                    {{ $t('add') }}
                </p>
            </li>
            <li v-if="CreateCardButtonActive && !createEnabled" class="lb-project-menu-item pt-4 pb-4 disabled" @mouseenter="openMessage" @mouseleave="closeMessage" @click="swapMessage">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-plus-circle-outline"></i>
                </span>
                
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('project.add_card') }}-->
                    {{ $t('add') }}
                </p>
            </li>

            <!-- new object -->
            <li v-if="CreateObjectButtonActive && createEnabled" 
                 class="lb-project-menu-item pt-4 pb-4" @click="$emit('toggleCreation')"
                :class="{ 'active': creationEnabled }">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px 
                        " :class="isTreasurehunt ? 'mdi-text-box-outline' : 'mdi-plus-circle-outline'"></i>

                </span>
                <p v-if="isTreasurehunt" class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_object_title') }}-->
                    {{ $t('add') }}
                </p>
                <p v-else class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('project.add_object') }}-->
                    {{ $t('add') }}
                </p>
            </li>
            <li v-if="CreateObjectButtonActive && !createEnabled" class="lb-project-menu-item pt-4 pb-4 disabled" @mouseenter="openMessage" @mouseleave="closeMessage" @click="swapMessage">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px 
                        " :class="isTreasurehunt ? 'mdi-text-box-outline' : 'mdi-plus-circle-outline'"></i>

                </span>
                <p v-if="isTreasurehunt" class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_object_title') }}-->
                    {{ $t('add') }}
                </p>
                <p v-else class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('project.add_object') }}-->
                    {{ $t('add') }}
                </p>
            </li>

            <li v-if="CreateQuestionButtonActive && createEnabled" 
                 class="lb-project-menu-item pt-4 pb-4" @click="$emit('toggleCreation')"
                :class="{ 'active': creationEnabled }">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px mdi-help-circle-outline
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_question_title') }}-->
                    {{ $t('add') }}
                </p>
            </li>
            <li v-if="CreateQuestionButtonActive && !createEnabled &&!sessionStarted" class="lb-project-menu-item pt-4 pb-4 disabled" @mouseenter="openMessage" @mouseleave="closeMessage" @click="swapMessage">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px mdi-help-circle-outline
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_question_title') }}-->
                    {{ $t('add') }}
                </p>
            </li>

            <li v-if="CreateQuestionGroupButtonActive && createEnabled" 
                 class="lb-project-menu-item pt-4 pb-4" @click="$emit('toggleCreation')"
                :class="{ 'active': creationEnabled }">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px mdi-help-box-multiple-outline
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_question_group_title') }}-->
                    {{ $t('add') }}
                </p>
            </li>
            <li v-if="CreateQuestionGroupButtonActive && !createEnabled &&!sessionStarted" class="lb-project-menu-item pt-4 pb-4 disabled" @mouseenter="openMessage" @mouseleave="closeMessage" @click="swapMessage">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px mdi-help-box-multiple-outline
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_question_group_title') }}-->
                    {{ $t('add') }}
                </p>
            </li>

            <li v-if="CreateClueButtonActive && createEnabled" 
                 class="lb-project-menu-item pt-4 pb-4" @click="$emit('toggleCreation')"
                :class="{ 'active': creationEnabled }">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px mdi-paw
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_clue_title') }}-->
                    {{ $t('add') }}
                </p>
            </li>
            <li v-if="CreateClueButtonActive && !createEnabled &&!sessionStarted" class="lb-project-menu-item pt-4 pb-4 disabled" @mouseenter="openMessage" @mouseleave="closeMessage" @click="swapMessage">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-36px mdi-paw
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('new_clue_title') }}-->
                    {{ $t('add') }}
                </p>
            </li>

            <!-- new point -->
            <li v-if="CreatePointButtonActive && createEnabled" 
                 class="lb-project-menu-item pt-4 pb-4" @click="$emit('toggleCreation')"
                :class="{ 'active': creationEnabled }">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-48px mdi-map-marker-multiple-outline
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('add_point') }}-->
                    {{ $t('add') }}
                </p>
            </li>
            <li v-if="CreatePointButtonActive && !createEnabled" class="lb-project-menu-item pt-4 pb-4 disabled" @mouseenter="openMessage" @mouseleave="closeMessage" @click="swapMessage">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-48px mdi-map-marker-multiple-outline
                        "></i>

                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('add_point') }}-->
                    {{ $t('add') }}
                </p>
                
            </li>

            <!-- edit object -->
            <li v-if="editObject" 
                 class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': editionEnabled }">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px"
                        :class="isTreasurehunt ? 'mdi-text-box-outline' : 'mdi-pencil-circle-outline'"></i>
                </span>
                <p v-if="isTreasurehunt" class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('edit_object_title') }}-->
                    {{ $t('edit') }}
                </p>
                <p v-else class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('project.edit_object') }}-->
                    {{ $t('edit') }}
                </p>
            </li>

            <li v-if="editQuestion"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': editionEnabled }">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-help-circle-outline"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('edit_question_title') }}-->
                    {{ $t('edit') }}
                </p>
            </li>

            <li v-if="editQuestionGroup"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': editionEnabled }">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-help-box-multiple-outline"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('edit_question_group_title') }}-->
                    {{ $t('edit') }}
                </p>
            </li>

            <li v-if="editClue"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': editionEnabled }"
                @click="$emit('toggleCreation')">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-paw"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('edit_clue_title') }}-->
                    {{ $t('edit') }}
                </p>
            </li>

            <li v-if="editPoint"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': editionEnabled }">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi mdi-48px mdi-map-marker-multiple-outline
                        "></i>
                </span>

                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    <!--{{ $t('edit_point_title') }}-->
                    {{ $t('edit') }}
                </p>
            </li>

            <!-- settings -->
            <li v-if="isProjectAdmin"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': showSettings }"
                @click="$emit('toggleSettings')">
                <span class="icon py-4 px-0">
                    <i class="
                                    mdi
                                    mdi-36px
                                    mdi-cog-outline
                                "></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('project.settings_menu') }}
                </p>
            </li>

            <!-- show answers -->
            <li v-if="(projectFormat == 'PROJECT_TYPE_QUIZ' || projectFormat == 'PROJECT_TYPE_QUIZHUNT') && isProjectAdmin"  class="lb-project-menu-item pt-3 pb-2" :class="{ 'active': showingAnswers }"
                @click="$emit('toggleAnswers')">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-table-eye"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('project.showAnswers') }}
                </p>
            </li>

            <!-- object list -->
            <li v-if="CanViewObjectList" class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': showObjectList }"
                @click="$emit('toggleObjectList')">
                <span class="icon py-4 px-0">
                    <i class="
                            mdi
                            mdi-36px
                            mdi-format-list-bulleted-square
                        "></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('project.object_list') }}
                </p>
            </li>

            <!-- project active session -->
            <li v-if="canManageSessions && sessionStarted" class="lb-project-menu-item pt-3 pb-2"
                :class="{ 'active': showActiveSession }" @click="$emit('toggleSessionActive')">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-48px mdi-dice-multiple-outline"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('game_session_active') }}
                </p>
            </li>

            <!-- project sessions -->
            <li v-if="canManageSessions && canShowGameStats" class="lb-project-menu-item pt-3 pb-2" :class="{ 'active': showListSessions }"
                @click="$emit('toggleListSessions')">
                <span class="icon py-4 px-0">
                    <!--<i class="mdi mdi-36px mdi-trophy-outline"></i>-->
                    <i class="mdi mdi-48px mdi-flag-checkered"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('game_session_list') }}
                </p>
            </li>

            <!-- project history -->
            <!-- <li v-if="hasEditionPermission && canShowHistory"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': showHistory }"
                @click="$emit('toggleHistory')">
            -->
                <!--<span
                    v-if="project.pendingChanges"
                    class="badge lb-project-header-badge mdi-font"
                    >{{ project.pendingChanges }}</span
                >-->
            <!--    <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-history"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('project_history_option') }}
                </p>

            </li>
            
            <li v-if="hasEditionPermission && !canShowHistory" class="lb-project-menu-item pt-4 pb-4 disabled"
                @click="toggleHistoryMessage" @mouseenter="openHistoryMessage" @mouseleave="closeHistoryMessage">
                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-history"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('project_history_option') }}
                </p>

            </li>-->

            <li v-if="isProjectAdmin"  class="lb-project-menu-item pt-4 pb-4" :class="{ 'active': showShare }"
                @click="$emit('toggleShare')">

                <span class="icon py-4 px-0">
                    <i class="mdi mdi-36px mdi-account-group-outline"></i>
                </span>
                <p class="is-size-6 has-text-centered pt-3 primary-font">
                    {{ $t('project_share_option') }}
                </p>

            </li>

        </ul>

        <!-- PLAY CONTROLS -->
        <ul role="tablist" class="is-bottom-positioned" v-if="canManageSessions">

            <li v-if="!sessionStarted && isProjectAdmin"
                class="lb-project-menu-item py-2 mx-2 mb-2 has-background-eduloc-green" @click="$emit('startSession')">
                <p class="icon is-medium">
                    <i class="mdi mdi-36px mdi-play has-text-white"></i>
                </p>
                <p class="is-size-6 has-text-centered has-text-white">
                    {{ $t('game_session_start') }}
                </p>
            </li>

            <li v-if="sessionPaused && isProjectAdmin"
                class="lb-project-menu-item py-2 mx-2 mb-2 has-background-eduloc-green" @click="$emit('continueSession')">
                <p class="is-size-6 has-text-centered has-text-white pb-1">
                    {{ $t('game_session_continue') }}
                </p>
            </li>

            <li v-if="sessionStarted && !sessionPaused && isProjectAdmin"
                class="lb-project-menu-item py-2 mx-2 mb-2 has-background-eduloc-yellow" @click="$emit('pauseSession')">
                <p class="is-size-6 has-text-centered has-text-black pb-1">
                    {{ $t('game_session_pause') }}
                </p>
            </li>

            <li v-if="sessionStarted && isProjectAdmin"
                class="lb-project-menu-item pb-2 pt-0 mx-2 mb-2 has-background-eduloc-red" @click="$emit('stopSession')">
                <p class="icon is-large">
                    <i class="mdi mdi-32px mdi-stop-circle-outline has-text-white"></i>
                </p>
                <p class="is-size-6 has-text-centered has-text-white">
                    {{ $t('game_session_stop') }}
                </p>
            </li>
        </ul>

        <div class="notification cannot-create secondary-font" v-if="showNoMoreObjectsMessage" v-html="$t('cannot_create_more_objects')" />
        <div class="notification cannot-create secondary-font" v-if="showHistoryMessage" v-html="$t('cannot_show_history')" />
         
    </div>
</template>

<script>

import _ from 'underscore';
import tippy, { createSingleton } from 'tippy.js';

export default {
    components: {

    },
    data() {
        return {
            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,
            newProjectMenuSingleton: {},
            newProjectMenuTippyInstances: {},
            showNoMoreObjectsMessage: false,
            showHistoryMessage: false,

        };
    },
    props: {
        canCreateObject: { type: Boolean, default: false },
        creationEnabled: { type: Boolean, default: false },
        canEditObject: { type: Boolean, default: false },
        editionEnabled: { type: Boolean, default: false },
        isProjectAdmin: { type: Boolean, default: false },
        isTrivial: { type: Boolean, default: false },
        hasCreationPermission: { type: Boolean, default: false },
        hasEditionPermission: { type: Boolean, default: false },
        showHistory: { type: Boolean, default: false },
        showSettings: { type: Boolean, default: false },
        projectFormat: { type: String, default: "" },
        showObjectList: { type: Boolean, default: false },
        showingAnswers: { type: Boolean, default: false },
        sessionStarted: { type: Boolean, default: false },
        sessionPaused: { type: Boolean, default: false },
        showListSessions: { type: Boolean, default: false },
        showActiveSession: { type: Boolean, default: false },
        objectType: { type: String, default: "" },
        showShare: { type: Boolean, default: false },
    },
    computed: {
        CreateObjectButtonActive() {
            return this.canCreateObject && !this.editionEnabled && (this.projectFormat == "PROJECT_TYPE_WALL" || (this.projectFormat == "PROJECT_TYPE_TREASUREHUNT" && this.objectType == "object"))
        },
        CreatePointButtonActive() {
            return !this.editionEnabled && this.projectFormat == "PROJECT_TYPE_MAP"
        },
        CreateQuestionButtonActive() {
            return  !this.editionEnabled && (this.projectFormat == "PROJECT_TYPE_QUIZ" || this.projectFormat == "PROJECT_TYPE_QUIZHUNT" || this.objectType == "question")
        },
        CreateQuestionGroupButtonActive() {
            return !this.editionEnabled && (this.projectFormat == "PROJECT_TYPE_GEOQUIZ" || this.objectType == "questionGroup")
        },
        CreateClueButtonActive() {
            return !this.editionEnabled && this.objectType == "clue";
        },
        CreateCardButtonActive() {
            return !this.editionEnabled && this.projectFormat == "PROJECT_TYPE_MEMORY"
        },
        CanViewObjectList() {
            return (this.projectFormat == "PROJECT_TYPE_GEOQUIZ" || this.projectFormat == "PROJECT_TYPE_MAP") && this.$store.getters.projectContent.length > 0
        },
        canManageSessions() {
            return this.isProjectAdmin && (this.projectFormat == "PROJECT_TYPE_QUIZ" || this.projectFormat == "PROJECT_TYPE_QUIZHUNT" || this.projectFormat == "PROJECT_TYPE_GEOQUIZ" || this.projectFormat == "PROJECT_TYPE_TREASUREHUNT" || this.projectFormat == "PROJECT_TYPE_MEMORY")
        },
        editObject() {
            return this.canEditObject && (this.projectFormat == "PROJECT_TYPE_WALL" || this.objectType == "object")
        },
        editPoint() {
            return this.canEditObject && this.projectFormat == "PROJECT_TYPE_MAP"
        },
        editQuestion() {
            return this.canEditObject && (this.projectFormat == "PROJECT_TYPE_QUIZ" || this.projectFormat == "PROJECT_TYPE_QUIZHUNT"|| this.objectType == "question")
        },
        editQuestionGroup(){
            return this.canEditObject && (this.projectFormat == "PROJECT_TYPE_GEOQUIZ")
        },
        editClue() {
            return this.canEditObject && this.objectType == "clue";
        },
        isTreasurehunt() {
            return this.projectFormat == 'PROJECT_TYPE_TREASUREHUNT';
        },
        canShowHistory() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.project.viewHistory
            }
            return false;
        },
        canShowGameStats() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.project.gameStats
            }
            return false;
        },
        createEnabled() {
            return this.canCreateObject;
        }
    },
    watch: {
    },
    methods: {
        openMessage() {
            //this.newProjectMenuTippyInstances.show();
            this.showNoMoreObjectsMessage = true;
        },
        closeMessage() {
            this.showNoMoreObjectsMessage = false;
        },
        swapMessage() {
            this.showNoMoreObjectsMessage = !this.showNoMoreObjectsMessage;
        },
        openHistoryMessage() {
            //this.newProjectMenuTippyInstances.show();
            this.showHistoryMessage = true;
        },
        closeHistoryMessage() {
            this.showHistoryMessage = false;
        },
        toggleHistoryMessage() {
            this.showHistoryMessage = !this.showNoMoreObjectsMessage;
        },

    },
    mounted: function () {
        //console.log(this.projectFormat)
        
        
    },
};
</script>

<style scoped>
    li.disabled{
        cursor: not-allowed;
        opacity: 0.2;
    }
    .cannot-create{
        position: absolute;
        max-width: 350px;
        top: 50px;
        left: 145px;
        background-color: #000000;
        color: #FFFFFF;
        text-align: left;
        opacity: 0.8;
    }
</style>
